import React from 'react'
import { useTranslation } from 'react-i18next'
import { immigrateCategoryRemovePA } from 'features/immigrate-category/store'
import { useAsyncDispatch, useNotify } from 'hooks'

export const useCategoryRemove = () => {
  const { t } = useTranslation()

  const { showNotification } = useNotify()

  const { loading, onAsyncDispatch } = useAsyncDispatch()

  const onSubmit = async (id, onSuccess) => {
    try {
      const data = await onAsyncDispatch(immigrateCategoryRemovePA.request, { id })

      onSuccess && onSuccess({ ...data })

      showNotification({
        type: 'success',
        message: t('removed_successfully'),
      })
    } catch (error) {
      const message = error?.message || t('error')
      showNotification({ type: 'error', message: message })
    }
  }

  return {
    onSubmit,
    loading,
  }
}
